__turbopack_context__.v({
  "TopSection": "jsqDkq_TopSection",
  "heading": "jsqDkq_heading",
  "socials": "jsqDkq_socials",
});
